import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UserManagementService } from '../user-management.service';
import Swal from 'sweetalert2';
import { SignupconfirmComponent } from "../signup-confirm/signup-confirm.component"
import { ModalService } from "src/app/service/modal.service";

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
    standalone: false
})
export class SignupComponent implements OnInit {
  signupForm: FormGroup;
  hidePassword = true;
  hideConfirmPassword = true;
  username: string = '';
  availabilityMessage: string = '';
  isAvailable: boolean | null = null; // true: available, false: unavailable, null: no check yet



  constructor(private fb: FormBuilder,private userService: UserManagementService,private activeModal: NgbActiveModal,private mservice: ModalService) {}

  ngOnInit() {
    this.signupForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]], // Improved regex
      phone_number: ['', [Validators.required]],
      pass: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/)
        ]
      ],
      confirmPassword: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
  }
  
  getErrorMessage(controlName: string): string {
    const control = this.signupForm.get(controlName);
    if (control?.hasError('required')) {
      return `${controlName.charAt(0).toUpperCase() + controlName.slice(1)} is required`;
    }
    if (control?.hasError('email')) {
      return 'Invalid email address';
    }
    if (control?.hasError('minlength')) {
      return `Minimum length is ${control.errors?.['minlength'].requiredLength} characters`;
    }
    if (control?.hasError('pattern')) {
      if (controlName === 'pass') {
        return 'Password must include uppercase, lowercase, and a number.';
      }
      return 'Invalid format';
    }
    if (controlName === 'confirmPassword' && this.signupForm.hasError('mismatch')) {
      return 'Passwords do not match';
    }
    return '';
  }
  

  passwordMatchValidator(g: FormGroup) {
    return g.get('pass')?.value === g.get('confirmPassword')?.value
      ? null : { 'mismatch': true };
  }


  onSubmit() {
    if (this.signupForm.valid) {
      let request={
          username:this.signupForm.value.username,
          firstName:this.signupForm.value.firstName,
          lastName:this.signupForm.value.lastName,
          password:this.signupForm.value.pass,
          email:this.signupForm.value.email,
          phone_number:this.signupForm.value.phone_number
        }
        
        this.userService.signup(request).then((response: any) => {
          if (response && response.status == 1) {
            this.activeModal.dismiss();
            this.openSignupConfirmModal(this.signupForm.value.username);
          }
      })

    } else {
      Object.keys(this.signupForm.controls).forEach(key => {
        const control = this.signupForm.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }
  showAlert(msg) {
    Swal.fire({
      title: msg,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
  }
  private openSignupConfirmModal(username) {
    const modalRef = this.mservice.open(SignupconfirmComponent, {
      options: {
        backdrop: false,
        keyboard: true,
      }
    });
    modalRef.componentInstance.username = username
    
  }
  public dissmissModal() {
    this.activeModal.dismiss();
  }
  checkUsernameAvailability(username: string): void {
    if (username.trim().length < 3) {
      this.availabilityMessage = 'Username must be at least 3 characters long.';
      this.isAvailable = null;
      return;
    }
    let request={
      username:this.signupForm.value.username
    }
    this.userService.isUsernameAvailable(request).then((response: any) => {
    
        if (response.status==1) {
          this.availabilityMessage = 'Username is available!';
          this.isAvailable = true;
        } else {
          this.availabilityMessage = 'Username is already taken.';
          this.isAvailable = false;
        }
      });
  }

}